<div
  [class.hidden]="isCollapsed"
  id="lesson-sidebar"
  class="lesson-sidebar bg-white shadow-md h-full rounded-b-lg overflow-y-auto"
>
  <div class="lesson-sidebar-header border-b flex">
    <div class="py-4 pl-4 flex-grow">
      <h2 class="text-xl font-semibold">
        {{ (courseChapters$ | async)?.title || '-' }}
      </h2>
    </div>
    <button
      (click)="toggleSidebar()"
      id="toggle-sidebar"
      class="text-gray-500 hover:text-gray-700 focus:outline-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
        />
      </svg>
    </button>
  </div>

  <div class="px-4 pt-2 pb-3 border-b bg-gray-50">
    <div class="course-progress">
      <div
        class="flex justify-between text-sm text-gray-600 mb-1"
        *ngIf="(userParticipation$ | async)?.status === 'certified'"
      >
        <span
          >Completed: {{ ((userParticipation$ | async)?.total ?? 0) - 1 || 0 }} /
          {{ ((userParticipation$ | async)?.total ?? 0) - 1 || 0 }}</span
        >
      </div>
      <div
        class="flex justify-between text-sm text-gray-600 mb-1"
        *ngIf="(userParticipation$ | async)?.status !== 'certified'"
      >
        <span
          >Completed: {{ (userParticipation$ | async)?.completed || 0 }} /
          {{ ((userParticipation$ | async)?.total ?? 0) - 1 || 0 }}</span
        >
      </div>
      <div
        class="h-2 bg-gray-200 rounded-full overflow-hidden"
        *ngIf="(userParticipation$ | async)?.status === 'certified'"
      >
        <div
          class="h-full bg-green-500 rounded-full"
          [style.width.%]="
            (((userParticipation$ | async)?.total || 0) /
              (((userParticipation$ | async)?.total ?? 0) - 1 || 0)) *
            100
          "
        ></div>
      </div>
      <div
        class="h-2 bg-gray-200 rounded-full overflow-hidden"
        *ngIf="(userParticipation$ | async)?.status !== 'certified'"
      >
        <div
          class="h-full bg-green-500 rounded-full"
          [style.width.%]="
            (((userParticipation$ | async)?.completed || 0) /
              (((userParticipation$ | async)?.total ?? 0) - 1 || 0)) *
            100
          "
        ></div>
      </div>
    </div>
  </div>

  <div class="p-3">
    <div
      class="chapter-item mt-2 mb-4"
      *ngFor="let chapter of (courseChapters$ | async)?.chapters; let i = index"
    >
      <div class="flex items-start mb-3">
        <div
          class="chapter-number"
          [ngClass]="{
            completed: isChapterCompleted(chapter),
            incomplete: !isChapterCompleted(chapter),
          }"
        >
          {{ i + 1 }}
        </div>
        <h3 class="font-medium">{{ chapter.title }}</h3>
      </div>

      <div class="lesson-items">
        <div class="lesson-progress-line"></div>
        <div class="lesson-item py-2" *ngFor="let item of chapter.chapter_items; let j = index">
          <div class="flex items-start">
            <div
              class="lesson-icon mr-2"
              [ngClass]="{
                current: item.content.uuid === currentItemUuid,
                completed: item.content.user_progress === 100,
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                ></path>
              </svg>
            </div>
            <div>
              <div class="flex items-center">
                <a
                  [routerLink]="getCourseChapterItemRoute(item.type, item.content.uuid)"
                  [attr.aria-disabled]="
                    getCourseChapterItemRoute(item.type, item.content.uuid) === null ? 'true' : null
                  "
                  [class.pointer-events-none]="
                    getCourseChapterItemRoute(item.type, item.content.uuid) === null
                  "
                  class="text-sm"
                  [ngClass]="{ 'current-lesson-text': item.content.uuid === currentItemUuid }"
                >
                  <span
                    [ngClass]="{
                      'line-through': item.content.user_progress === 100,
                    }"
                    >{{ i + 1 }}.{{ j + 1 }} {{ item.content.title }}</span
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  [class.hidden]="!isCollapsed"
  id="collapsed-sidebar"
  class="lesson-sidebar collapsed bg-white shadow-md h-full hidden overflow-y-auto rounded-b-lg"
>
  <div class="p-3 border-b flex justify-center">
    <button
      (click)="toggleSidebar()"
      id="expand-sidebar"
      class="text-gray-500 hover:text-gray-700 focus:outline-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 5l7 7-7 7M5 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>

  <div class="py-4">
    <div
      class="chapter-item-container"
      *ngFor="let chapter of (courseChapters$ | async)?.chapters; let i = index"
    >
      <div class="flex justify-center relative">
        <div class="lesson-progress-line"></div>
        <div
          class="chapter-number"
          [ngClass]="{
            completed: isChapterCompleted(chapter),
            incomplete: !isChapterCompleted(chapter),
          }"
        >
          {{ i + 1 }}
        </div>
      </div>

      <div
        class="flex justify-center relative"
        *ngFor="let item of chapter.chapter_items; let j = index"
      >
        <a
          [routerLink]="getCourseChapterItemRoute(item.type, item.content.uuid)"
          [attr.aria-disabled]="
            getCourseChapterItemRoute(item.type, item.content.uuid) === null ? 'true' : null
          "
          [class.pointer-events-none]="
            getCourseChapterItemRoute(item.type, item.content.uuid) === null
          "
          class="lesson-icon"
          [ngClass]="{ current: item.content.uuid === currentItemUuid }"
          [ngClass]="{
            current: item.content.uuid === currentItemUuid,
            completed: item.content.user_progress === 100,
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>
